import React, { useEffect, useState, useRef } from "react";
import { useForm, Controller } from "react-hook-form";
import {
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  InputAdornment,
  TableRow,
  Paper,
  Button,
  useMediaQuery,
  Switch,
  FormControlLabel,
} from "@mui/material";
import { addAuctionTransaction } from "../../gateway/auction-transaction-apis";
import TextField from "@mui/material/TextField";
import SearchIcon from "@mui/icons-material/Search";
import Autocomplete from "@mui/material/Autocomplete";
import { getAllItems, addNewEntry } from "../../gateway/curdDB";
import styles from "./auction-transaction.css";
import { Delete, AddCircleOutline, Edit } from "@mui/icons-material";
import Snackbar from "@mui/material/Snackbar";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Alert from "@mui/material/Alert";
import { useOutletContext } from "react-router-dom";
import OnGoingAuctions from "../../dialogs/ongoing-auctions/ongoing-auctions";
import { StyledTableCell } from "../../shared/ui/elements/Table-Cell";
import AlertDialog from "../../dialogs/corformation/conformation";
function AuctionTransaction() {
  function getUTCDateTimeFromDateOnly(dateString) {
    const now = new Date(); // current local time
    const hours = now.getHours();
    const minutes = now.getMinutes();
    const seconds = now.getSeconds();
    const milliseconds = now.getMilliseconds();

    // Create a local Date with selected date + current time
    const localDateTime = new Date(`${dateString}T${pad(hours)}:${pad(minutes)}:${pad(seconds)}.${pad(milliseconds, 3)}`);

    // Convert to UTC ISO string
    return new Date(localDateTime).toISOString();
  }

  function pad(num, size = 2) {
    return num.toString().padStart(size, "0");
  }

  const {
    control,
    getValues,
    formState: { errors },
    register,
    trigger,
    reset,
    setValue,
    setFocus,
    watch,
  } = useForm({
    defaultValues: {
      date: new Date().toLocaleDateString("en-CA"),
    },
  });
  const [itemsList, setItemsList] = useState([]);
  const [kisanList, setKisanList] = useState([]);
  const [vyapariList, setVyapariList] = useState([]);
  const [buyItemsArr, setTableData] = useState([]);
  const [open, setOpen] = useState(false);
  const [isOnGoingAuctionOpen, setIsOnGoingAuctionOpen] = useState(false);
  const [qtyTotal, setQtyTotal] = useState(0);
  const [openSuccessTransactionDialog, setSuccessTransactionDialog] = useState(false);
  const { loading } = useOutletContext();
  const vyapariRef = useRef(null); // Create a ref
  let indexToDelete;
  const matches = useMediaQuery("(min-width:600px)");
  const matchesTwo = useMediaQuery("(max-width:599px)");
  const [qty, setQty] = useState([]);
  const [auctionId, setAuctionId] = useState([]);
  const kisanRef = useRef(null);
  const itemRef = useRef(null);
  const totalBagInputRef = useRef(null);
  // const auctionType = watch("auctionType");
  // const auctionType = false;
  const [openConformationDialog, setOpenConformationDialog] = useState(false);
  const [deleteRow, setDeleteRow] = useState();

  const onSubmit = async () => {
    const data = getValues();
    const isValid = await trigger(["kisaan", "itemName"]);

    if (isValid && buyItemsArr.length) {
      const buyItems = buyItemsArr?.map((obj) => {
        const { vyapariName, ...rest } = obj;
        return rest;
      });
      const auctionData = {
        kisanId: data.kisaan.partyId,
        itemId: data.itemName.itemId,
        buyItems,
        // auctionDate: `${data.date}T${new Date().toISOString().split("T")[1]}`,
        auctionDate: getUTCDateTimeFromDateOnly(data.date),
      };
      try {
        await addAuctionTransaction(auctionData);
        setSuccessTransactionDialog(true);
        reset();
        setValue("kisaan", null);
        setValue("itemName", null);
        setValue("totalBag", null);
        setTableData([]);
        let oldLocal = JSON.parse(localStorage.getItem("onGoingAuction"));
        let newLocal = oldLocal;
        delete newLocal[auctionId];
        localStorage.setItem("onGoingAuction", JSON.stringify(newLocal));
        document.title = `Mandi Auction`;
        if (kisanRef.current) {
          setTimeout(() => {
            kisanRef.current.focus();
          }, 0);
        }
      } catch (error) {
        console.log(error);
      }
    } else {
      if (!buyItemsArr.length) {
        setOpen(true);
      }
    }
  };

  const addBag = (event, adding) => {
    event.preventDefault();
    const currentVal = getValues("bags");
    if (adding) {
      setValue("bags", Number(currentVal) + 1, { shouldValidate: true, shouldDirty: true });
    } else {
      setValue("bags", Number(currentVal) - 1, { shouldValidate: true, shouldDirty: true });
    }
  };

  const addToTable = async (event) => {
    if (event) {
      event.preventDefault();
    }
    const result = await trigger(["kisaan", "itemName", "vyapari", "bags", "chungi", "rate", "date"]);
    if (result) {
      const values = getValues();
      const newAuctionRow = {
        vyapariName: values.vyapari.name,
        vyapariId: values.vyapari.partyId,
        rate: Number(values.rate),
        bagWiseQuantity: [],
        auctionDate: getUTCDateTimeFromDateOnly(values.date).slice(0, -1),
        // auctionDate: new Date(`${values.date}T${new Date().toISOString().split("T")[1].slice(0, -1)}`).toISOString(),
        // auctionDate: `${values.date}T${new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false })}`,
      };


      newAuctionRow.quantity = Number(values.quantity);
      newAuctionRow.bags = Number(values.bags);
      newAuctionRow.chungi = Number(values.chungi || 0);
      addNewEntry({ trId: Number(Date.now().toString()), ...newAuctionRow, kisanName: values.kisaan.name, itemName: values.itemName.name });

      let newTableData = [newAuctionRow, ...buyItemsArr];

      setTableData(newTableData);
      setQty([]);
      setQtyTotal(0);
      setValue("vyapari", null);
      setValue("bags", "");
      setValue("quantity", null);

      const currAuctionSate = {
        formValues: getValues(),
        arrayData: newTableData,
        id: auctionId,
      };
      let oldLocal = JSON.parse(localStorage.getItem("onGoingAuction"));
      oldLocal[auctionId] = currAuctionSate;
      localStorage.setItem("onGoingAuction", JSON.stringify(oldLocal));

      vyapariRef.current.focus();
    } else {
      console.log("Validation failed");
    }
  };

  const editFromTable = (index) => {
    const defaultOption = vyapariList.find((option) => option.name == buyItemsArr[index]?.vyapariName);
    reset({
      ...getValues(),
      ...buyItemsArr[index],
      vyapari: defaultOption,
    });
    setQty(buyItemsArr[index]?.bagWiseQuantity);
    setQtyTotal(buyItemsArr[index]?.quantity);
    const newRows = [...buyItemsArr];
    newRows.splice(index, 1);
    setTableData(newRows);
  };

  const deleteFromTable = (index) => {
    indexToDelete = index;
    setOpenConformationDialog(true);
  };

  useEffect(() => {
    if (deleteRow) {
      const newRows = [...buyItemsArr];
      newRows.splice(indexToDelete, 1);
      setTableData(newRows);

      const currAuctionSate = {
        formValues: getValues(),
        arrayData: newRows,
        id: auctionId,
      };
      let oldLocal = JSON.parse(localStorage.getItem("onGoingAuction"));
      if (newRows.length == 0) {
        let newLocal = oldLocal;
        delete newLocal[auctionId];
        localStorage.setItem("onGoingAuction", JSON.stringify(newLocal));
      } else {
        oldLocal[auctionId] = currAuctionSate;
        localStorage.setItem("onGoingAuction", JSON.stringify(oldLocal));
      }
    }
  }, [deleteRow]);

  const fetchList = async (listName) => {
    try {
      const list = await getAllItems(listName);
      switch (listName) {
        case "VYAPARI":
          setVyapariList(list);
          break;
        case "KISAN":
          setKisanList(list);
          break;
        case "items":
          const uniqueArray = list.filter((item, index, self) => index === self.findIndex((obj) => obj.name === item.name));
          setItemsList(uniqueArray);
          break;
        default:
          break;
      }
    } catch (error) {
      console.error("Fetch items error:", error);
    }
  };

  useEffect(() => {
    const anyPreviousAuctions = JSON.parse(localStorage.getItem("onGoingAuction"));
    if (anyPreviousAuctions && Object.keys(anyPreviousAuctions)?.length > 0) setIsOnGoingAuctionOpen(true);
    else {
      const newAuction = {};
      localStorage.setItem("onGoingAuction", JSON.stringify(newAuction));

      const newAuctionId = Date.now().toString(16);
      setAuctionId(newAuctionId);
      kisanRef.current.focus();
    }
  }, []);

  useEffect(() => {
    fetchList("VYAPARI");
    fetchList("KISAN");
    fetchList("items");
  }, [loading]);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
    setSuccessTransactionDialog(false);
  };

  const newQty = (event) => {
    event.preventDefault();
    const value = getValues("quantity");
    const rateValue = getValues("rate");
    if (!value) {
      if (!rateValue) {
        setFocus("rate");
        return;
      }
      addToTable();
      setFocus("vyapari");
      return;
    }
    setQty([...qty, value]);
    setQtyTotal((prev) => Number(prev) + Number(value));
    // const currentVal = getValues("bags");
    // setValue("bags", Number(currentVal) + 1, { shouldValidate: true, shouldDirty: true });
    setValue("quantity", "", { shouldValidate: false, shouldDirty: true });
  };

  const removeQty = (event, index) => {
    event.preventDefault();
    const newQty = [...qty];
    newQty.splice(index, 1);
    setQty(newQty);
    setQtyTotal((prev) => Number(prev) - Number(qty[index]));
    const currentVal = getValues("bags");
    setValue("bags", Number(currentVal) - 1, { shouldValidate: true, shouldDirty: true });
  };

  const vasuliDays = (maxLoanDays, lastVasuliDateString) => {
    const todaysDate = new Date();
    const lastVasuliDate = new Date(lastVasuliDateString);
    const diffInMs = Math.abs(todaysDate - lastVasuliDate);
    const diffInDays = Math.ceil(diffInMs / (1000 * 60 * 60 * 24));
    return diffInDays > maxLoanDays;
  };

  const action = (
    <React.Fragment>
      <IconButton size="small" aria-label="close" color="inherit" onClick={handleClose}>
        <CloseIcon fontSize="small" />
      </IconButton>
    </React.Fragment>
  );

  const handleCloseDialog = (data) => {
    setIsOnGoingAuctionOpen(false);
    if (data) {
      reset(data?.formValues);
      setTableData(data.arrayData);
      setAuctionId(data.id);
      document.title = data?.formValues?.kisaan?.name;
    } else {
      const newAuctionId = Date.now().toString(16);
      setAuctionId(newAuctionId);
    }
    if (vyapariRef.current) {
      setTimeout(() => {
        vyapariRef.current.focus();
      }, 0);
    }
  };

  const fieldValueChange = (event, fieldName) => {
    if (fieldName === "kisaan") itemRef.current.focus();
    if (getValues()?.kisaan?.name) {
      document.title = getValues().kisaan.name;
    } else {
      document.title = `Mandi Auction`;
    }
  };

  const handleEnterKeyPress = (val) => {

    const rateValue = getValues("rate");

    if (val === "frombags") {
      if (!rateValue) setFocus("rate");
      else addToTable();
    }
    else if (val === "fromrate") addToTable();
  };

  const debounceTimeout = useRef(null);

  const autoSetVyapari = (event) => {
    clearTimeout(debounceTimeout.current);
    debounceTimeout.current = setTimeout(() => {
      setValue(
        "vyapari",
        vyapariList.find((option) => {
          const val = event.target.value.toLowerCase();
          if (option.name.toLowerCase() == val || option.idNo == val) {
            setFocus("quantity");
          }
          return option.name.toLowerCase() == val || option.idNo == val;
        })
      );
    }, 100);
  };

  useEffect(() => {
    return () => clearTimeout(debounceTimeout.current);
  }, []);

  const changeAuctionType = () => {
    // setAuctionType((prevState) => !prevState);
  };

  const handleConformationClose = (action) => {
    setOpenConformationDialog(false);
    setDeleteRow(action);
  };

  return (
    <>
      <div className="wrapper">
        <form>
          <div className="container">
            <div className="auction_date">
              <Controller
                name="date"
                control={control}
                rules={{ required: "Enter selectDate" }}
                defaultValue=""
                render={({ field }) => (
                  <TextField
                    {...field}
                    fullWidth
                    type="date"
                    size="small"
                    label="Select Date"
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                )}
              />
              <p className="err-msg">{errors.date?.message}</p>
            </div>
            <div className="submit-area">
              <Button type="button" variant="contained" color="primary" onClick={onSubmit}>
                Submit
              </Button>
            </div>
            <div className="kisan">
              <Controller
                name="kisaan"
                control={control}
                rules={{ required: "Enter Kisaan Name" }}
                render={({ field }) => (
                  <Autocomplete
                    {...field}
                    value={field.value || null}
                    options={kisanList}
                    disabled={getValues()?.kisaan?.name && buyItemsArr.length > 0}
                    getOptionLabel={(option) => `${option.id} | ${option.name}`}
                    filterOptions={(options, state) =>
                      options
                        .filter(
                          (option) =>
                            option.name.toUpperCase().includes(state.inputValue.toUpperCase()) || option.idNo.includes(state.inputValue)
                        )
                        .slice(0, 5)
                    }
                    isOptionEqualToValue={(option, value) => option.id === value.id}
                    renderOption={(props, option) => (
                      <li {...props}>
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <span>
                            <strong>ID:</strong> {option.id} | <strong>Name:</strong> {option.name}
                          </span>
                        </div>
                      </li>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="KISAAN"
                        size="small"
                        disabled={getValues()?.kisaan?.name && buyItemsArr.length > 0}
                        InputProps={{
                          ...params.InputProps,
                          inputRef: kisanRef, // Attach the ref here
                          // startAdornment: (
                          //   <InputAdornment position="start">
                          //     <SearchIcon />
                          //   </InputAdornment>
                          // ),
                        }}
                        inputProps={{
                          ...params.inputProps,
                          style: {
                            textTransform: "uppercase", // Ensure uppercase transformation here
                          },
                        }}
                      />
                    )}
                    onChange={(event, value) => {
                      field.onChange(value);
                      fieldValueChange(event, "kisaan");
                    }}
                    disablePortal
                    id="combo-box-demo"
                  />
                )}
              />
              <p className="err-msg">{errors.kisaan?.message}</p>
            </div>
            <div className="item">
              <Controller
                name="itemName"
                control={control}
                rules={{ required: "Enter Item" }}
                render={({ field }) => (
                  <Autocomplete
                    {...field}
                    value={field.value || null}
                    options={itemsList}
                    disabled={getValues()?.itemName && buyItemsArr.length > 0}
                    getOptionLabel={(option) => option.name}
                    isOptionEqualToValue={(option, value) => option.itemId === value.itemId}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="ITEM"
                        size="small"
                        InputProps={{
                          ...params.InputProps,
                          inputRef: itemRef,
                          // startAdornment: (
                          //   <InputAdornment position="start">
                          //     <SearchIcon />
                          //   </InputAdornment>
                          // ),
                        }}
                        inputProps={{
                          ...params.inputProps,
                          style: {
                            textTransform: "uppercase", // Ensure uppercase transformation here
                          },
                        }}
                      />
                    )}
                    onChange={(event, value) => {
                      field.onChange(value); // Updates the React Hook Form state
                      vyapariRef.current.focus();
                      // setFocus("vyapari");
                    }}
                    disablePortal
                    id="combo-box-demo"
                  />
                )}
              />
              <p className="err-msg">{errors.itemName?.message}</p>
            </div>
            {/* <div className="totalBags">
              <Controller
                name="totalBag"
                control={control}
                defaultValue=""
                rules={{ required: "Enter Total Bags" }}
                render={({ field, fieldState: { error } }) => (
                  <TextField
                    {...field}
                    fullWidth
                    label="Total Bags"
                    size="small"
                    placeholder="Total Bags"
                    type="number"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    variant="outlined"
                    error={!!error}
                    inputRef={totalBagInputRef}
                  />
                )}
              />
              <p className="err-msg">{errors.totalBag?.message}</p>
            </div> */}
            <div className="vyapari">
              <Controller
                name="vyapari"
                control={control}
                rules={{ required: "Enter Vyapari Name" }}
                render={({ field }) => (
                  <Autocomplete
                    {...field}
                    value={field.value || null}
                    options={vyapariList}
                    getOptionLabel={(option) => `${option.idNo} | ${option.name}`}
                    filterOptions={(options, state) =>
                      options
                        .filter(
                          (option) =>
                            option.name.toUpperCase().includes(state.inputValue.toUpperCase()) || option.idNo.includes(state.inputValue)
                        )
                        .slice(0, 10)
                    }
                    isOptionEqualToValue={(option, value) => option.idNo === value.idNo}
                    renderOption={(props, option) => (
                      <li {...props}>
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <span>
                            {option.idNo} <strong>|</strong> {option.name}
                          </span>
                          {vasuliDays(option.maxLoanDays, option.lastVasuliDate) && (
                            <div
                              style={{
                                width: "10px",
                                height: "10px",
                                backgroundColor: "red",
                                marginLeft: "4px",
                                borderRadius: "50%", // Makes it a circle
                                display: "inline-block", // Ensures it stays inline
                              }}
                            ></div>
                          )}
                        </div>
                      </li>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="VYAPARI"
                        size="small"
                        InputProps={{
                          ...params.InputProps,
                          inputRef: vyapariRef,
                        }}
                        inputProps={{
                          ...params.inputProps,
                          style: {
                            textTransform: "uppercase", // Ensure uppercase transformation here
                          },
                        }}
                        onInput={autoSetVyapari}
                      />
                    )}
                    onChange={(event, value) => {
                      field.onChange(value); // Updates the React Hook Form state
                      setFocus("quantity");
                    }}
                    disablePortal
                    id="combo-box-demo"
                  />
                )}
              />
              <p className="err-msg">{errors.vyapari?.message}</p>
            </div>
            <div className="quantity">
              {/* <div className="qty-input"> */}
              <div>
                <>
                  <TextField
                    {...register("quantity", { required: "Enter Quantity" })}
                    fullWidth
                    size="small"
                    label="QUANTITY"
                    type="number"
                    placeholder="Quantity"
                    variant="outlined"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault();
                        setFocus("bags");
                      }
                    }}
                  />
                  <p className="err-msg">{errors.quantity?.message}</p>
                </>
              </div>
              {/* <button className="add-qty-btn" onClick={newQty}>
                  A
                </button> */}
              {/* </div> */}
              {/* <div className="quantity-list">
                <ul className="horizontal-list">
                  {qty?.map((item, index) => (
                    <li key={index}>
                      {item}
                      <button className="qty-btn" onClick={(event) => removeQty(event, index)}>
                        x
                      </button>
                    </li>
                  ))}
                </ul>
                <div className="qty-total">{qtyTotal}</div>
              </div> */}
            </div>
            <div className="bags-box">
              {/* <div className="bag"> */}
              <TextField
                {...register("bags", { required: "Bags is required" })}
                fullWidth
                size="small"
                label="Bags"
                placeholder="Bags"
                type="number"
                variant="outlined"
                InputLabelProps={{
                  shrink: true,
                }}
                inputProps={{
                  tabIndex: -1,
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    handleEnterKeyPress("frombags");
                  }
                }}
              />
              <p className="err-msg">{errors.bags?.message}</p>
              {/* </div> */}
              {/* <div className="btn-1 count-btn">
                <button onClick={(event) => addBag(event, true)} className="add-btn secondary-btn one">
                  +
                </button>
                <button onClick={(event) => addBag(event, false)} className="add-btn secondary-btn one two">
                  -
                </button>
              </div> */}
            </div>
            <div className="rate">
              <TextField
                {...register("rate", { required: "Rate is required" })}
                fullWidth
                size="small"
                label="RATE"
                type="number"
                placeholder="Rate"
                variant="outlined"
                InputLabelProps={{
                  shrink: true,
                }}
                inputProps={{
                  tabIndex: -1,
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    handleEnterKeyPress("fromrate");
                  }
                }}
              />
              {errors.rate && <p className="err-msg">{errors.rate.message}</p>}
            </div>
            <div className="chungi">
              <TextField
                {...register("chungi", { required: "Chungi is required" })}
                fullWidth
                label="Chungi"
                size="small"
                placeholder="Chungi"
                defaultValue={10}
                type="number"
                variant="outlined"
                InputLabelProps={{
                  shrink: true,
                }}
                inputProps={{
                  tabIndex: -1,
                }}
              />
              <p className="err-msg">{errors.chungi?.message}</p>
            </div>
            <div className="btn-2">
              <button onClick={(event) => addToTable(event)} className="add-btn">
                Add Entry <AddCircleOutline fontSize="small" />
              </button>
            </div>
            <div className="full-grid">
              <TableContainer component={Paper} className="table_container">
                <Table stickyHeader>
                  <TableHead>
                    <TableRow style={{ display: matches ? "table-row" : "none" }}>
                      <TableCell align="left">
                        <b>VYAPARI NAME</b>
                      </TableCell>
                      <TableCell align="left">
                        <b>QUANTITY</b>
                      </TableCell>
                      <TableCell align="left">
                        <b>RATE</b>
                      </TableCell>
                      <TableCell align="left">
                        <b>BAGS</b>
                      </TableCell>
                      <TableCell align="left">
                        <b>CHUNGI</b>
                      </TableCell>
                      <TableCell align="left">
                        <b>COMMISSION</b>
                      </TableCell>
                      <TableCell>
                        <b>TOTAL</b>
                      </TableCell>
                      <TableCell align="centre">
                        <b>EDIT</b>
                      </TableCell>
                      <TableCell align="centre">
                        <b>DELETE</b>
                      </TableCell>
                    </TableRow>
                    <TableRow style={{ display: matchesTwo ? "table-row" : "none" }}>
                      <TableCell align="left">VYAPARI</TableCell>
                      <TableCell align="left">Q</TableCell>
                      <TableCell align="left">R</TableCell>
                      <TableCell align="left">B</TableCell>
                      <TableCell align="left">CH</TableCell>
                      <TableCell align="left">CO</TableCell>
                      <TableCell align="left">T</TableCell>
                      <TableCell align="centre">E</TableCell>
                      <TableCell align="centre">D</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {buyItemsArr?.map((row, index) => (
                      <TableRow key={index}>
                        <StyledTableCell sx={{ width: "45%" }} align="left">
                          {row.vyapariName}
                        </StyledTableCell>
                        <StyledTableCell align="left">{row.quantity}</StyledTableCell>
                        <StyledTableCell align="left">{row.rate}</StyledTableCell>
                        <StyledTableCell align="left">{row.bags}</StyledTableCell>
                        <StyledTableCell align="left">{row.chungi}</StyledTableCell>
                        <StyledTableCell align="left">{row.chungi * row.bags}</StyledTableCell>
                        <StyledTableCell align="left">{(row.rate * row.quantity) + (row.chungi * row.bags)}</StyledTableCell>
                        <StyledTableCell align="centre">
                          <Button onClick={() => editFromTable(index)}>
                            <Edit />
                          </Button>
                        </StyledTableCell>
                        <StyledTableCell align="centre">
                          <Button onClick={() => deleteFromTable(index)}>
                            <Delete />
                          </Button>
                        </StyledTableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          </div>
        </form>
        <div>
          <Snackbar
            open={open}
            autoHideDuration={1000}
            message="ADD ATLEST ONE TRANSACTION"
            action={action}
            onClose={handleClose}
            anchorOrigin={{ vertical: "top", horizontal: "right" }}
          />
        </div>
        <div>
          <Snackbar
            open={openSuccessTransactionDialog}
            autoHideDuration={1000}
            onClose={handleClose}
            anchorOrigin={{ vertical: "top", horizontal: "right" }}
          >
            <Alert onClose={handleClose} severity="success" variant="filled" sx={{ width: "100%" }}>
              TRANSACTION SUCCESSFULLY ADDED.
            </Alert>
          </Snackbar>
        </div>
        <OnGoingAuctions open={isOnGoingAuctionOpen} onClose={handleCloseDialog} />
        <AlertDialog open={openConformationDialog} handleClose={handleConformationClose} />
      </div>
    </>
  );
}

export default AuctionTransaction;
